import styled, { createGlobalStyle } from 'styled-components'
import { Card, Button } from 'react-bootstrap'
import {
  OPPORTUNITY_COMPANY_LIST_THUMBNAIL_HEIGHT,
  OPPORTUNITY_COMPANY_LIST_THUMBNAIL_WIDTH,
  OPPORTUNITY_COVER_HEIGHT,
  OPPORTUNITY_COVER_WIDTH,
} from '../../opportunityCoverDimensions'

export const MobileContainerPadding = createGlobalStyle`
  @media (max-width: 768px) {
    .row.px-0.mx-0 > .container {
      padding: 80px 16px;
    }
  }
`

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
  gap: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
`

export const PageTitle = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
`

export const PageSubtitle = styled.p`
  font-size: 1rem;
  color: #4b5563;
  margin: 0;
`

export const SearchSection = styled.div`
  width: 50%;
  max-width: 50%;
  margin-bottom: 2rem;

  @media (max-width: 992px) {
    width: 100%;
    max-width: 100%;
  }
`

export const OpportunitiesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const OpportunityCard = styled(Card)`
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 5px rgba(38, 43, 47, 0.07);
  padding: 16px;
  height: auto;
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
  transition: box-shadow 0.2s;
  background-color: #ffffff;

  &:hover {
    box-shadow: 0 6px 10px rgba(38, 43, 47, 0.1);
  }
`

export const CardContent = styled.div`
  display: flex;
  align-items: stretch;
  gap: 1.5rem;
  width: 100%;
  height: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    height: auto;
  }
`

export const CardImageWrapper = styled.div`
  flex-shrink: 0;
  width: ${OPPORTUNITY_COMPANY_LIST_THUMBNAIL_WIDTH}px;
  height: ${OPPORTUNITY_COMPANY_LIST_THUMBNAIL_HEIGHT}px;
  max-width: 100%;
  align-self: center;
  border-radius: 8px;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    aspect-ratio: ${OPPORTUNITY_COVER_WIDTH} / ${OPPORTUNITY_COVER_HEIGHT};
  }
`

export const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
`

export const CardBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
  min-width: 0;
  min-height: 0;
  align-self: stretch;
  overflow: hidden;
`

export const CardTextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 0;
  overflow: hidden;
`

export const CardTitle = styled.h5`
  font-family: 'Caixa Std', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  line-height: 20px;
  color: #464646;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const CardDescription = styled.p`
  font-family: 'Caixa Std', sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  color: #464646;
  margin: 0;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-word;
`

export const CardMeta = styled.p`
  font-family: 'Caixa Std', sans-serif;
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
  margin: 0;
  line-height: 20px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  min-height: 32px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 0.75rem;
  }
`

export const ViewButton = styled(Button)`
  && {
    width: 160px;
    min-width: 160px;
    height: 32px;
    min-height: 32px;
    padding: 6px 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: 1px solid #00599c;
    border-radius: 4px;
    background-color: #ffffff;
    color: #00599c;
    font-family: 'Caixa Std', sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    text-align: center;
    white-space: nowrap;
    flex-shrink: 0;
    box-sizing: border-box;
    box-shadow: none;
  }

  &&:hover,
  &&:focus {
    background-color: #f0f9ff;
    border-color: #00599c;
    color: #00599c;
    box-shadow: none;
  }
`

export const PaginationFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1.5rem;
  gap: 0.75rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`

export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
`

export const PaginationNavButton = styled.button`
  border: none;
  background: none;
  color: #0066B3;
  padding: 0;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:not(:disabled) {
    cursor: pointer;
    opacity: 1;
  }
`

export const PaginationPrevButton = styled(PaginationNavButton)`
  margin-right: 0.5rem;
`

export const PaginationNextButton = styled(PaginationNavButton)`
  margin-left: 0.5rem;
`

export const PaginationChevronIcon = styled.i`
  font-size: 1.2rem;
`

export const ItemsPerPageLabel = styled.div`
  color: #0066B3;
`

export const EmptySearchMessage = styled.p`
  text-align: center;
  color: #6b7280;
  margin: 2rem 0;
`
